module.exports = __webpack_public_path__ + "img/vpc.f2ad124.webp";